import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getScanSatus } from '../../../utilities/common';

export default function DriverDispatches(props){
    const { driverDispatches } = props;
    const {t} = useTranslation('editOrder'); 

    return (
        <div style={{width: '100%'}}>
            <div 
                style={{
                    display: 'flex', 
                    justifyContent: 'space-between',
                    marginBottom: 20
                }}
            >
                <div style={{width:'20%'}}>{t('driver_id')}</div>
                <div style={{width:'20%'}}>{t('scan_status')}</div>
                <div style={{width:'40%'}}>{t('scan_time')}</div>
            </div>
            {
                driverDispatches?.length > 0 ?
                driverDispatches.map((driverDispatch) => {
                    return (
                        <div
                            style={{
                                paddingTop: 10,
                                paddingBottom: 10,
                                marginBottom: 20,
                                display: 'flex',
                                width: '100%',
                                justifyContent: 'space-between'
                            }}
                        >
                            <div style={{ width: '20%' }}>{driverDispatch.driver_id}</div>
                            <div
                                style={{
                                    whiteSpace: 'pre-wrap',
                                    overflowWrap: 'break-word',
                                    width: '20%'
                                }}
                            >
                                {t(getScanSatus(driverDispatch.status))}
                            </div>
                        <div
                            style={{
                                whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word',
                                width: '40%'
                            }}
                        >
                            {driverDispatch.scan_time}
                        </div>
                        </div>
                    )
                })
                    :
                    <div></div>
            }
        </div>
    )
}